if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			// Gallery thumbnails

			if ( this.productSlider ) {

				const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).offsetTop + this.offsetTop,
									behavior: 'smooth'
								});
								this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
							productGaleryThumbnails.scrollTo({
								left: elm.offsetLeft - 50,
								behaviour: 'smooth'
							})
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('change', e=>{
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				if ( this.productGallery.dataset.jsDisableParallax == 'false' ) {
					this.productSlider.addEventListener('ready', (e)=>{
						
						if ( this.firstProductGalleryIndex ) {
							this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
						}

						const productSlides = this.productSlider.querySelectorAll('.product-gallery-item');
						const productFigures = this.querySelectorAll('.apply-gallery-animation');
						this.productSlider.addEventListener('scroll', ()=>{
							const scrollX = -this.productSlider.element.scrollLeft;
							productSlides.forEach((slide,i)=>{
								const media = productFigures[i];
								if ( media ) {
									media.style.transform = `translateX(${( slide.offsetLeft + scrollX ) * -1/3}px)`;
								}
							});
						});

					});
				}

			}

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && ( KROWN.settings.cart_action == 'overlay' || KROWN.settings.cart_action == 'popup' ) ) {
				
				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
							window.lastFocusedElm = this.querySelector('[data-js-product-add-to-cart]');
						}
					})
				}	

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
						if ( document.getElementById('cart-recommendations') ) {
							document.getElementById('cart-recommendations').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
								addToCartEnter = false;
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}


			// Product variant event listener for theme specific logic

			if ( this.dataset.snaksTemplate === 'true' && this.productGallery ) {
				this._galleryContainer = this.productGallery.querySelector('.product-gallery-items');
				this._thumbnailsContainer = this.productGallery.querySelector('.product-gallery__thumbnails-holder');
				if ( this._galleryContainer ) {
					this._originalGalleryItems = Array.from(this._galleryContainer.querySelectorAll('.product-gallery-item'));
				}
				if ( this._thumbnailsContainer ) {
					this._originalThumbnails = Array.from(this._thumbnailsContainer.querySelectorAll('.thumbnail'));
				}
			}

			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if ( this.productVariants ) {
				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:this.productVariants});
			}

		}

		swapGalleryNodes(nodeA, nodeB) {
			if ( ! nodeA || ! nodeB || nodeA === nodeB || nodeA.parentNode !== nodeB.parentNode ) {
				return;
			}
			const parent = nodeA.parentNode;
			const placeholder = document.createComment('swap');
			parent.insertBefore(placeholder, nodeA);
			parent.insertBefore(nodeA, nodeB);
			parent.insertBefore(nodeB, placeholder);
			parent.removeChild(placeholder);
		}

		updateGalleryIndices() {
			if ( ! this._galleryContainer ) {
				return;
			}
			this._galleryContainer.querySelectorAll('.product-gallery-item').forEach((item, i) => {
				item.dataset.index = i;
				item.classList.toggle('gallery-item-first', i === 0);
			});
		}

		restoreGalleryOrder() {
			if ( ! this._galleryContainer || ! this._originalGalleryItems ) {
				return;
			}
			this._originalGalleryItems.forEach(item => {
				this._galleryContainer.appendChild(item);
			});
			this._originalGalleryItems.forEach((item, i) => {
				item.dataset.index = i;
				item.classList.toggle('gallery-item-first', i === 0);
			});
			if ( this._thumbnailsContainer && this._originalThumbnails ) {
				this._originalThumbnails.forEach(thumb => {
					this._thumbnailsContainer.appendChild(thumb);
				});
				this._originalThumbnails.forEach((thumb, i) => {
					thumb.dataset.index = i;
				});
			}
		}

		swapSnaksVariantImage(variant) {
			this.restoreGalleryOrder();

			if ( ! variant || variant.featured_media == null || ! this._galleryContainer ) {
				return;
			}

			const defaultItem = this._galleryContainer.querySelector('.product-gallery-item');
			const variantItem = this._galleryContainer.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');

			if ( ! variantItem || variantItem === defaultItem ) {
				return;
			}

			const variantIndex = parseInt(variantItem.dataset.index, 10);
			this.swapGalleryNodes(defaultItem, variantItem);
			this.updateGalleryIndices();

			if ( this._thumbnailsContainer && this._originalThumbnails ) {
				const defaultThumb = this._thumbnailsContainer.querySelector('.thumbnail');
				const variantThumb = this._thumbnailsContainer.querySelector('.thumbnail[data-index="' + variantIndex + '"]');
				if ( defaultThumb && variantThumb && defaultThumb !== variantThumb ) {
					this.swapGalleryNodes(defaultThumb, variantThumb);
					this._thumbnailsContainer.querySelectorAll('.thumbnail').forEach((thumb, i) => {
						thumb.dataset.index = i;
					});
				}
			}
		}

		showFirstGallerySlide() {
			const firstItem = this._galleryContainer && this._galleryContainer.querySelector('.product-gallery-item');
			if ( ! firstItem ) {
				return;
			}
			if ( this.productSlider && this.productSlider.sliderEnabled ) {
				this.productSlider.changeSlide(0);
			} else {
				window.scrollTo({
					top: firstItem.offsetTop + this.offsetTop,
					behavior: 'smooth'
				});
			}
			this.thumbnailNavigationHelper(0);
		}

		thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				if ( i == index )
					elm.classList.add('active');
				else 
					elm.classList.remove('active');
			});
		}

		onVariantChangeHandler(e){

			let variant = e.target.currentVariant;
			if ( variant ) {

				if ( this.dataset.snaksTemplate === 'true' ) {
					this.swapSnaksVariantImage(variant);
					this.showFirstGallerySlide();
					return;
				}
				
				// image handling

				if ( variant.featured_media != null ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							window.scrollTo({
								top: variantImg.offsetTop,
								behavior: 'smooth'
							});
						}
					}
				}

			}
		}
	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}